<template>
<!--  <div>-->


    <b-form-group  label-for="user-name">
<!--            <validation-provider-->
<!--                #default="{ errors }"-->
<!--                :name="fieldsData.name"-->
<!--                :rules="fieldsData.required == 1 ? 'required' : ''">-->
              <label  v-html="fieldsData.label[selectlang]"></label>
<!--      v-validate="'required'"-->
      <b-form-input
          :required="isRequired(fieldsData.required)"
          :maxLength="fieldsData.maxLength"
          :minLength="fieldsData.minLength"
          :name="fieldsData.name"
                    :value="fieldsData.id"
                    :placeholder="fieldsData.hint[selectlang]"
                    :type="fieldsData.inputType =='phone'?'number':fieldsData.inputType"
                    @input="UpdateValue($event)"
                    @keypress="(fieldsData.inputType === 'phone' || fieldsData.inputType === 'number') ? onlyNumber($event) : ''"
                    :formatter="formatterFunction"
                    class="form-control"></b-form-input>
      <span v-show="hasErrors(fieldsData.name)">{{ getFirstError(fieldsData.name) }}</span>

<!--      <span v-show="errors.has(fieldsData.name)">{{ errors.first(fieldsData.name) }}</span>-->


<!--      oninput="this.value = this.value.replace(/^0/, '');this.value = this.value.replace(/^[^6-9][0-9]*/, '');"-->
      <small class="text-danger" v-if="errorshow">{{ fieldsData.error[selectlang] }}</small>
<!--            </validation-provider>-->
    </b-form-group>
<!--  </div>-->
</template>

<script>
// import {ValidationProvider} from "vee-validate";
// import {required} from "@validations";
export default {
  components: {
    // ValidationProvider,
  },
  // props: {
  //   fieldsData: {
  //     // type: Object,
  //     // default: () => fieldsData,
  //   },
  // },
  data() {
    return {
      // errors: [],
      DataArray:{},
      errorshow:false,
      // required,
    };
  },
  props: ['fieldsData','selectlang'],



  created() {

  },

  methods: {
    isRequired(requiredValue) {

      // Check if fieldsData.required is equal to 1
      return requiredValue == 1;
    },
    hasErrors(fieldName) {

      return this.$parent.errors && this.$parent.errors[fieldName] ? true : false;
    },
    getFirstError(fieldName) {

      return this.$parent.errors && this.$parent.errors[fieldName] ? this.$parent.errors[fieldName][0] : '';
    },
    UpdateValue(value){
      // console.log(value);
      const lenmax =this.fieldsData.maxLength;
      const lenmin=this.fieldsData.minLength;
      const lenval=value.length
      this.$emit('input',value)
      if (lenval < lenmin || lenval > lenmax){
        this.errorshow=true;
      }
      else
      {
        this.errorshow=false;
      }
    },
    // updateFormData() {
    //   const payload = {
    //     key: this.fieldsData.name,
    //     value: this.DataArray[this.fieldsData.name]
    //   };
    //   // Emit event with payload containing both key and value
    //   this.$emit('updateFieldData', payload);
    // },

    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

      formatterFunction(e) {
        return String(e).substring(0, this.fieldsData.maxLength);
      },


    // formatterFunction(inputType,fieldName) {
    //   // console.log(this.fieldsData.maxLength);
    //
    //   if ((fieldName === 'phonenumber2' || fieldName === 'whatsappNumber') && (inputType === 'phone' || inputType === 'number')){
    //     return this.validMobile;
    //   }
    //   else if (fieldName === 'pincode' && (inputType === 'phone' || inputType === 'number')) {
    //     // alert(minLength);
    //     // alert(maxLength);
    //     return this.validatePincode;
    //   }
    //   return null;
    // },
    // validMobile(e) {
    //
    //   return String(e).substring(0, 10);
    // },
    // validatePincode(e) {
    //   // alert(this.fieldsData.maxLength);
    //   let inputValue= String(e).substring(0, 6); // Limit to maxLength characters
    //   if (inputValue.length < 6) {
    //     e.preventDefault();
    //   }
    //   return inputValue;
    // }


  }
}
</script>

<style>
/* Add your styles here */
</style>
